/**
 * useLifecycleRoles — los roles que puede usar un proyecto con ese ciclo
 * (OT-0006): los de la metodología del ciclo y el vocabulario genérico de
 * su dueño (`GET /templates?lifecycle_id=`, `lifecycle_template_ids` en el
 * backend). Sin ciclo (proyectos anteriores a elegirlo) o con un ciclo sin
 * metodología, no hay a qué acotar y se ofrece el catálogo completo.
 *
 * Lo comparten el wizard de proyecto y la vista de Equipo para que las
 * dos ofrezcan los mismos roles.
 */

import { useQuery } from '@tanstack/react-query'

import { listTemplates } from '../api/templates'
import { useAccessToken } from '../auth/useAccessToken'

export function useLifecycleRoles(lifecycleId: string | null | undefined) {
  const { accessToken } = useAccessToken()
  return useQuery({
    queryKey: ['templates', 'list', 'role', 'lifecycle', lifecycleId ?? null],
    queryFn: () => {
      if (!accessToken) throw new Error('no_access_token')
      return listTemplates(accessToken, {
        template_type: 'role',
        lifecycle_id: lifecycleId ?? undefined,
      })
    },
    enabled: !!accessToken,
    staleTime: 60_000,
    retry: false,
  })
}
